<div class="grid-container margin-top">

  <organization-form [(organization)]="organization" [(parentOrganization)]="parentOrganization" [readOnly]="!canEditOrg" (readOnlyChange)="canEditOrg = $event"></organization-form>

  @if (displayDeptLabel) {
    <div>
      <div class="grid-x margin-top">
        <div class="cell small-12">
          <h4>Organization Departments</h4>
        </div>
      </div>
    </div>
  }

  <organization-departments [(organization)]="organization"></organization-departments>

  <div class="grid-x margin-top">
    <div class="cell small-12">
      <h4>Organization Documents</h4>
    </div>
  </div>
  <div class="margin-bottom-large">
    @if (organization != null) {
      <on-base-organization-documents [organization]="organization"></on-base-organization-documents>
    }
  </div>
</div>
